const PRODUCTS = {
  // v1 products
  PERSONAL: 578353,
  PLUS: 638029,
  PRO: 580502,
  PLUS_UPGRADE: 638030,
  // v2 products
  TRIAL: 661578,
  BASIC: 798586,
  PLUS_V2: 798587,
  COMPLETE: 798588,
  // v2 subscriptions
  INDIE: 765053,
  COMPANY: 772304,
  ENTERPRISE: 772305,
};

module.exports = { PRODUCTS };
